// extracted by mini-css-extract-plugin
export var deleteModal = "_il-0";